interface IconNotifyProps {
  active?: boolean;
}
export const IconNotify = ({ active }: IconNotifyProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2 2.25C4.4121 2.25 3.65998 2.57026 3.10811 3.13467C2.5568 3.69851 2.25 4.45972 2.25 5.25V18.75C2.25 19.5403 2.5568 20.3015 3.10811 20.8653C3.65998 21.4297 4.4121 21.75 5.2 21.75H11.4667C11.8809 21.75 12.2167 21.4142 12.2167 21C12.2167 20.5858 11.8809 20.25 11.4667 20.25H5.2C4.82094 20.25 4.45391 20.0962 4.18062 19.8167C3.90677 19.5366 3.75 19.1532 3.75 18.75V5.25C3.75 4.8468 3.90677 4.46342 4.18062 4.18335C4.45391 3.90384 4.82094 3.75 5.2 3.75H14H17.5C17.9802 3.75 18.4312 3.92852 18.756 4.23171C19.0791 4.53327 19.25 4.93076 19.25 5.33333V10C19.25 10.4142 19.5858 10.75 20 10.75C20.4142 10.75 20.75 10.4142 20.75 10V5.33333C20.75 4.49823 20.3941 3.70874 19.7795 3.13513C19.1667 2.56315 18.3459 2.25 17.5 2.25H14H5.2Z"
        fill={active ? "#FF9934" : "#999999"}
      />
      <path
        d="M18.42 14.6102C18.615 14.4152 18.8465 14.2605 19.1013 14.155C19.3561 14.0494 19.6292 13.9951 19.905 13.9951C20.1808 13.9951 20.4539 14.0494 20.7087 14.155C20.9635 14.2605 21.195 14.4152 21.39 14.6102C21.585 14.8052 21.7397 15.0368 21.8452 15.2915C21.9508 15.5463 22.0051 15.8194 22.0051 16.0952C22.0051 16.371 21.9508 16.6441 21.8452 16.8989C21.7397 17.1537 21.585 17.3852 21.39 17.5802L18 21.0002H15V18.0002L18.42 14.6102Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9H15.5"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13H13"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
